import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-testimonials',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './testimonials.html',
  styleUrl: './testimonials.scss',
})
export class Testimonials {
  ts = inject(TranslationService);
  t = this.ts.t;
  active = signal(0);

  testimonials = [
    {
      name: 'Carlos Mendes',
      role: 'Gerente de Segurança',
      company: 'Vale S.A.',
      initials: 'CM',
      color: '#0066cc',
      quote: 'A implementação do sistema de monitoramento da Nautis Vision reduziu em 67% os incidentes na nossa operação de mineração. A detecção automática de EPIs transformou nossa cultura de segurança.'
    },
    {
      name: 'Ana Paula Rodrigues',
      role: 'Diretora de Operações',
      company: 'Petrobras',
      initials: 'AP',
      color: '#22c55e',
      quote: 'Integramos a solução da Nautis Vision com nosso sistema SCADA em menos de 72 horas. O suporte técnico é excepcional — respondem mais rápido do que qualquer outro fornecedor que já trabalhamos.'
    },
    {
      name: 'Ricardo Fontes',
      role: 'Head de TI Industrial',
      company: 'Gerdau',
      initials: 'RF',
      color: '#f59e0b',
      quote: 'Os dashboards de eficiência operacional nos deram visibilidade que nunca tivemos antes. Identificamos gargalos que custavam R$ 2M por ano e hoje operamos com 15% mais produtividade.'
    }
  ];

  setActive(i: number) { this.active.set(i); }
}
